// src/pages/Callback.jsx
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCognito } from "../utils/useCognito";
import { Spinner, Flex, Text, VStack } from "@chakra-ui/react";

export default function Callback() {
  const { isLoading, user, isAuthenticated } = useCognito();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Wait until Cognito finishes loading + checks session
    if (!isLoading && isAuthenticated && user) {
      // Check if there's a returnTo path in the location state
      const returnTo = location.state?.returnTo || "/dashboard";
      navigate(returnTo, { replace: true });
    }

    // If not loading and not authenticated, redirect to login
    if (!isLoading && !isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isLoading, isAuthenticated, user, navigate, location.state]);

  return (
    <Flex minH="100vh" align="center" justify="center">
      <VStack spacing={4}>
        <Spinner size="xl" />
        <Text color="gray.600">Processing authentication...</Text>
      </VStack>
    </Flex>
  );
}
